export default {
  loading: false,
  data: null,
  error: null,
  selected: {
    title: null,
  },
};
